import {
  FETCH_PAGINATED_PRODUCT_PACKAGINGS,
  FETCH_ALL_PRODUCT_PACKAGINGS,
  RESET_PRODUCT_PACKAGINGS,
  ADD_NULL_PRODUCT_PACKAGINGS,
} from '../../mutation-types';

export default {
  [FETCH_PAGINATED_PRODUCT_PACKAGINGS](state, { productPackagings, pagination }) {
    state.items = productPackagings;
    state.pagination = pagination;
  },

  [FETCH_ALL_PRODUCT_PACKAGINGS](state, productPackagings) {
    state.all = productPackagings;
  },

  [RESET_PRODUCT_PACKAGINGS](state) {
    state.all = [];
    state.items = [];
    state.pagination = {};
  },

  [ADD_NULL_PRODUCT_PACKAGINGS](state) {
    state.all.splice(0, 0, { id: '', name: '' });
  },
};



// WEBPACK FOOTER //
// ./src/app/store/modules/productPackaging/mutations.js